var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "details-view",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SystemMaintenance.TemplateApplicationSettings"),
        width: "650px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          staticClass: "main-content",
          staticStyle: { "margin-top": "10px", "margin-left": "10px" }
        },
        [
          _c("el-form-item", [
            _c(
              "span",
              {
                staticClass: "title",
                staticStyle: { "font-weight": "bold" },
                attrs: { slot: "label" },
                slot: "label"
              },
              [_vm._v(_vm._s(_vm.$t("SystemMaintenance.MatchingSettings")))]
            )
          ]),
          _c(
            "el-form-item",
            { staticStyle: { "margin-left": "10px" } },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.form.forbidManualChangeTemplate,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "forbidManualChangeTemplate", $$v)
                    },
                    expression: "form.forbidManualChangeTemplate"
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("SystemMaintenance.ManualSOPTemplatesIsAllowed")
                    )
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticStyle: { "margin-left": "10px" } },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.form.hidePromptOnTemplateAutoMatch,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "hidePromptOnTemplateAutoMatch", $$v)
                    },
                    expression: "form.hidePromptOnTemplateAutoMatch"
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "SystemMaintenance.DoTemplateIsAutomaticallyTemplate"
                      )
                    )
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okHandler } },
            [_vm._v(_vm._s(_vm.$t("Message.Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }